import qs from "qs";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { AchRecordUpdate } from "types";

export const achRejectService = {
	getAchRejectCsv,
	getAchRejectData,
	getAchRejectList,
	updateAchRejectRecord,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

const getQueryString = params =>
	Object.keys(params)
		.filter(key => params[key])
		.map(key => key + "=" + params[key])
		.join("&");

const mapAchRejectListParams = ({ page, filters, sortBy }) => {
	return {
		page_index: page,
		page_size: PAGE_SIZE,
		sort_type: sortBy?.id || undefined,
		ascending: sortBy?.id ? sortBy?.desc : undefined,
		// filters
		merchant_id: filters?.mid?.map(item => item?.id),
		return_code: filters?.returnCode?.map(item => item),
		agent_office_id: filters?.agentOffice?.map(item => item?.id),
		downloaded_from: filters?.sourceOfData?.map(item => item?.value),
		status: filters?.rejectStatus?.map(item => item?.value),

		processor: filters?.processor?.map(item => item?.name),
		primary_agent_id: filters?.primaryAgent?.map(item => item?.id),
		transaction_type: filters?.transactionType?.value,
		recover_sources: filters?.recoveredFrom?.map(item => item?.value),
		"merchant.is_held": filters?.accountOnHold?.value,
		"merchant.status": filters?.merchantStatus?.map(item => item?.name),
		"merchant.is_termination_letter_sent":
			filters?.terminationLetter?.value,
		updated_by_id: filters?.lastUpdatedBy?.map(item => item?.id),

		min_rejected_at: convertDateToISO(filters?.dateOfRejectFrom),
		max_rejected_at: convertDateToISO(filters?.dateOfRejectTo, {
			addTime: TIME_OFFSET_DAY_END,
		}),

		min_downloaded_at: convertDateToISO(filters?.dateDownloadedFrom),
		max_downloaded_at: convertDateToISO(filters?.dateDownloadedTo, {
			addTime: TIME_OFFSET_DAY_END,
		}),

		min_recovered_at: convertDateToISO(filters?.dateRecoveredFrom),
		max_recovered_at: convertDateToISO(filters?.dateRecoveredTo, {
			addTime: TIME_OFFSET_DAY_END,
		}),

		min_created_at: convertDateToISO(filters?.dateIngestedFrom),
		max_created_at: convertDateToISO(filters?.dateIngestedTo, {
			addTime: TIME_OFFSET_DAY_END,
		}),

		min_updated_at: convertDateToISO(filters?.dateUpdatedFrom),
		max_updated_at: convertDateToISO(filters?.dateUpdatedTo, {
			addTime: TIME_OFFSET_DAY_END,
		}),
	};
};

function getAchRejectCsv({
	page,
	filters,
	sortBy,
}: {
	page?: number;
	filters?: any;
	sortBy?: any;
}) {
	const params = getQueryString(
		mapAchRejectListParams({ page, filters, sortBy }),
	);
	const user = JSON.parse(localStorage.getItem("user") || "");
	const url = `${API_URL}/api/ach_reject/records/csv?token=${user.access_token}&${params}`;
	let link = document.createElement("a");
	link.href = url;
	link.click();
}

function getAchRejectList({ page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/ach_reject/records`,
		params: mapAchRejectListParams({ page, filters, sortBy }),
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getAchRejectData({ id }: { id: string }) {
	const options = {
		url: `${API_URL}/api/ach_reject/records/${id}`,
	};

	return axiosWithAuth(options);
}

function updateAchRejectRecord({
	id,
	model,
}: {
	id: string;
	model: AchRecordUpdate;
}) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/ach_reject/records/${id}`,
	};

	return axiosWithAuth(options);
}
